// ⌘K command palette strings (auto-merged by lib/i18n.ts).
export const en = {
  'cmdk.placeholder': 'Search or run a command…',
  'cmdk.no_matches': 'No matches.',
  'cmdk.search_all': 'Search everything for “{term}”',
  'cmdk.recent': 'Recent searches',
  'cmdk.clear_recent': 'Clear',
  'cmdk.po': 'PO',
  'cmdk.aria.palette': 'Command palette',
  'cmdk.aria.search_input': 'Search or run a command',
}

export const zhTW = {
  'cmdk.placeholder': '搜尋或執行指令…',
  'cmdk.no_matches': '沒有符合的結果。',
  'cmdk.search_all': '搜尋「{term}」的所有結果',
  'cmdk.recent': '最近搜尋',
  'cmdk.clear_recent': '清除',
  'cmdk.po': '採購單',
  'cmdk.aria.palette': '命令面板',
  'cmdk.aria.search_input': '搜尋或執行命令',
}
